import React, { CSSProperties } from 'react';
import { Grid, Chip, Typography, GridSize } from '@mui/material';
import colors from '../../../styles/colors';

interface BooleanChipItem {
    name: string;
    label: string;
    icon?: React.ReactNode;
}

interface Props {
    items: BooleanChipItem[];
    values: Record<string, any>;
    setFieldValue: (field: string, value: any) => void;
    mb: string;
    paddingX: string;
    styleContainer?: CSSProperties;
    md?: GridSize; 
}

const BooleanChips: React.FC<Props> = ({ items, values, setFieldValue, mb, paddingX, styleContainer, md }) => {

    return (
        <Grid 
            style={styleContainer}
            container
            spacing={2}
            textAlign="center"
            justifyContent="space-around"
            paddingX={paddingX}
            mb={mb}
            md={md}
        >
            {items.map(({ name, label, icon }, index) => (
                <Grid md={6} item key={name}
                    style={{ display: 'flex', flexDirection: 'column', marginTop: index === 0 ? '1rem' : 0,}}
                    className="flex flex-col justify-center items-center">
                    <Typography variant="body1">{label}</Typography>
                    <Chip
                        icon={icon as React.ReactElement | undefined}
                        label={values[name] ? 'Sim' : 'Não'}
                        sx={{
                            color: values[name] ? colors.IceWhite : colors.DarkerGray,
                        }}
                        color={values[name] ? 'primary' : 'default'}
                        onClick={() => setFieldValue(name, !values[name])}
                    />
                </Grid>
            ))}
        </Grid>
    );
};
export default BooleanChips;